export default __webpack_public_path__ + "static/media/Banner2.2e03224a.jpg";